import { STAFF_FIELD_LINKS } from "./options";
import s from "./TableRow.less";

const checkKeys = Object.keys(STAFF_FIELD_LINKS);

const compareFactToRequired = (fact: unknown, req: unknown) => {
  const reqToNum = Number(String(req ?? "").split("%")[0]);
  const factToNum = Number(String(fact ?? "").split("%")[0]);

  const reqNum = Number.isNaN(reqToNum) ? 0 : reqToNum;
  const factNum = Number.isNaN(factToNum) ? 0 : factToNum;

  return reqNum > factNum ? s.red_staff : s.green_staff;
};

export const getStaffCellToneClass = (
  item: Record<string, unknown>,
  optionName: string
): string | undefined => {
  if (!checkKeys.includes(optionName)) {
    return undefined;
  }
  const linkKey =
    STAFF_FIELD_LINKS[optionName as keyof typeof STAFF_FIELD_LINKS];
  return compareFactToRequired(item[optionName], item[linkKey]);
};
